/**
 * Applies style properties to the provided element.
 * 
 * @param HTMLElement $element
 * @param Object styles
 */
export default function($element, styles) {
    for (const [key, val] of Object.entries(styles)) {
        $element.style[key] = val;
    }
};
